import { Action } from '@ngrx/store';

import { Review } from '../review';

export enum ReviewHistoryActionTypes {
  REVIEW_HISTORY_SHOW_MODAL = '[Review history] show modal',
  REVIEW_HISTORY_HIDE_MODAL = '[Review history] hide modal',
  REVIEW_HISTORY_REQUESTED = '[Review history] review history requested',
  REVIEW_HISTORY_LOADED = '[Review history] review history loaded',
  REVIEW_HISTORY_LOADING_FAILED = '[Review history] review history loading failed',
}

export interface ListIdPayload {
  listId: string;
}

export class ReviewHistoryShowModalAction implements Action {
  readonly type = ReviewHistoryActionTypes.REVIEW_HISTORY_SHOW_MODAL;

  constructor(public payload: ListIdPayload) {}
}

export class ReviewHistoryHideModalAction implements Action {
  readonly type = ReviewHistoryActionTypes.REVIEW_HISTORY_HIDE_MODAL;

  constructor() {}
}

export class ReviewHistoryRequestedAction implements Action {
  readonly type = ReviewHistoryActionTypes.REVIEW_HISTORY_REQUESTED;

  constructor(public payload: ListIdPayload) {}
}

export interface ReviewHistoryPayload extends ListIdPayload {
  reviews: Review[];
}

export class ReviewHistoryLoadedAction implements Action {
  readonly type = ReviewHistoryActionTypes.REVIEW_HISTORY_LOADED;

  constructor(public payload: ReviewHistoryPayload) {}
}

export interface ReviewHistoryLoadingFailedPayload extends ListIdPayload {
  error: any;
}

export class ReviewHistoryLoadingFailedAction implements Action {
  readonly type = ReviewHistoryActionTypes.REVIEW_HISTORY_LOADING_FAILED;

  constructor(public payload: ReviewHistoryLoadingFailedPayload) {}
}

export type ReviewHistoryActions =
  | ReviewHistoryShowModalAction
  | ReviewHistoryHideModalAction
  | ReviewHistoryRequestedAction
  | ReviewHistoryLoadedAction
  | ReviewHistoryLoadingFailedAction;
